import { render, staticRenderFns } from "./NextModalFrame.vue?vue&type=template&id=0c87b5f3&"
import script from "./NextModalFrame.vue?vue&type=script&lang=js&"
export * from "./NextModalFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports